/* ALll URL should go here */

/* Webservice URl paths*/
const IS_LOGGED_ON = '/VGApp/iip/institutional/isLoggedOn'
const IGN_PUBLIC_HEADER_URL =
  '/ign-inst-investor-global-nav-webservice/rs/public/navigationIAM?isNGA=true&navItemSubSilo=CBD_NAV_NONE&isPublic=false&navItemSilo=CBD_NAV_ProdTools&suppressSocial=true'
const IGN_PROTECTED_HEADER_URL =
  '/ign-inst-investor-global-nav-webservice/rs/protected/navigationIAM?isNGA=true&navItemSubSilo=CBD_NAV_NONE&isPublic=false&navItemSilo=CBD_NAV_ProdTools&suppressSocial=true'
const VGN_SRC =
  'https://ccc.vgcontent.info/vg-vgn/latest/js/vgn.min.js?appPrefix=fd3'

/* Node URl paths*/
const NODE_FD3_VGN_CONTENT = 'vgn-content/vgnContent'
const IS_LOGON_B2B = '/b2blogon/user-status'
const TOGGLE_B2B_STATUS = '/graphql/execute.json/FD3/b2bLogonToggle'

export class PolarisUrls {
  static POLARIS_FUND_PROFILE_BASE_HOST = 'POLARIS_FUND_PROFILE_BASE_HOST'
  static POLARIS_BENCHMARK_PROFILE_BASE_HOST =
    'POLARIS_BENCHMARK_PROFILE_BASE_HOST'
  static POLARIS_PERFORMANCE_RETURNS_BASE_HOST =
    'POLARIS_PERFORMANCE_RETURNS_BASE_HOST'
  static POLARIS_FESS_EXP_BASE_HOST = 'POLARIS_FESS_EXP_BASE_HOST'
  static POLARIS_YIELDS_BASE_HOST = 'POLARIS_YIELDS_BASE_HOST'
  static POLARIS_FOI_DIVIDEND = 'POLARIS_FOI_DIVIDEND'
  static POLARIS_FOI_DEVELOPED = 'POLARIS_FOI_DEVELOPED'
  static POLARIS_FOI_NONUS = 'POLARIS_FOI_NONUS'
  static POLARIS_FOI_GLOBAL = 'POLARIS_FOI_GLOBAL'
  static FUND_NAMES = 'FUND_NAMES'
  static FUND_CHARACTERISTICS = 'FUND_CHARACTERISTICS'
  static FUND_CLASSIFICATIONS = 'FUND_CLASSIFICATIONS'
  static FUND_SHARECLASSES = 'FUND_SHARECLASSES'
  static FUND_TAXES = 'FUND_TAXES'
  static FUND_FLAGS = 'FUND_FLAGS'
  static FUND_IDENTIFIERS = 'FUND_IDENTIFIERS'
  static FUND_TRADINGS = 'FUND_TRADINGS'
  static FUND_RETURNS_MONTHLY = 'FUND_RETURNS_MONTHLY'
  static FUND_RETURNS_DAILY = 'FUND_RETURNS_DAILY'
  static BENCHMARK_RETURNS = 'BENCHMARK_RETURNS'
  static FEES_EXP = 'FEES_EXP'
  static BENCHMARK_NAMES = 'BENCHMARK_NAMES'
  static FUND_YIELDS = 'FUND_YIELDS'
  static FUND_DISTRIBUTION_GROUPS = 'FUND_DISTRIBUTION_GROUPS'
  static BENCHMARK_CHARACTERISTICS = 'BENCHMARK_CHARACTERISTICS'
  static POLARIS_DISTRIBUTIONS_BASE_HOST = 'POLARIS_DISTRIBUTIONS_BASE_HOST'
  static FUND_DIST_YIELDS_REAlESTATE = 'FUND_DIST_YIELDS_REAlESTATE'
  static FUND_YIELDS_REAlESTATE = 'FUND_YIELDS_REAlESTATE'
}

export class ConstantUrls {
  static IS_LOGGED_ON = IS_LOGGED_ON
  static IGN_PUBLIC_HEADER_URL = IGN_PUBLIC_HEADER_URL
  static IGN_PROTECTED_HEADER_URL = IGN_PROTECTED_HEADER_URL
  static VGN_SRC = VGN_SRC
  static NODE_FD3_VGN_CONTENT = NODE_FD3_VGN_CONTENT
  static TOGGLE_B2B_STATUS = TOGGLE_B2B_STATUS
  static IS_LOGON_B2B = IS_LOGON_B2B
}
export const NODE_POLARIS = 'polaris/fundList'
export const FD3_CONTENT_AEM_GRAPHQL = '/graphql/execute.json/FD3/fd3AllContent'
export const NODE_FD3_CONTENT = 'fd3-content/all'
export const ETF_DISCLOSURE = 'etf_disclosures/public.caasv3.json'
export const NODE_USER_TYPE = 'user-logon/userType'
export const FD3_FUND_LITERATURE_CONTENT =
  '/fd2-fund-details-csv-webservice/aggregateFundLiterature'
export const NODE_FUND_LITERATURE = 'fund-literature/content'
// export const NODE_FUND_LITERATURE = 'fund-literature/literatureData' // this is used for oauth endpoint

export const PRODUCT_DETAILS_URL = '/investments/product-details/fund/'
export const FUND_LITERATURE_ERROR_SVG_URL =
  '/assets/inst/iig-transformation/fundfiltering/Error.svg'
export const FUND_LITERATURE_ERROR_HOME_URL =
  '/content/iig-transformation/home.html'
export const NODE_FUND_LITERATURE_DOWNLOAD_PDF = 'fund-literature/downloadPdf'
